module.exports = __webpack_public_path__ + "static/6-9d6e58880bb533ebe3fe33248b4877c1.jpeg";